import React, { useMemo } from 'react';
import _ from 'lodash';

const { adapt } = LocaleUtils;
const { getLabel } = OptionUtils;

export const useGridData = (aftSummary, befSummary, calendarLeaves) => {

	const gridData = useMemo(() => {
		if (!aftSummary) return null;
		const calendarLeaveMap = _.keyBy(calendarLeaves, 'id');
		const gridData = [];

		// 已排時數
		gridData.push({
			key: 'workHours',
			name: getLabel('h2.am.ShiftingSidePanelComps', 'scheduledHours'),
			bef: befSummary?.workHours || 0,
			aft: aftSummary.workHours,
			dta: aftSummary.workHours - (befSummary?.workHours || 0),
			should: aftSummary.shouldWorkHourInfo?.workHour,
			shouldDiff: aftSummary.workHours - aftSummary.shouldWorkHourInfo?.workHour
		});
		// 行事曆類別 (只顯示 SP 有回傳的，並維持其順序) 停用不顯示, 停用項目有計算數字需顯示
		gridData.push(..._(aftSummary.calendarJson).map(data => {
			let bef = _.find(befSummary?.calendarJson, { id: data.id })?.num || 0;
			let aft = data.num;
			return {
				key: `calendar_${data.id}`,
				name: LocaleUtils.i18nIdx() === 1 ? `${getLabel('h2.am.ShiftingSidePanelComps', 'unitOfDays')} ${adapt(calendarLeaveMap[data.id]?.name||'')}` : `${adapt(calendarLeaveMap[data.id]?.name||'')}${getLabel('h2.am.ShiftingSidePanelComps', 'unitOfDays')}`,
				bef,
				aft,
				active: calendarLeaveMap[data.id]?.active || 0,
				dta: aft - bef,
				should: aftSummary.shouldWorkHourInfo?.[`leave${data.id}`],
				shouldDiff: aft - aftSummary.shouldWorkHourInfo?.[`leave${data.id}`]
			};
		}).filter(f => f.bef>0 || f.aft>0 || f.active).value());
		// 時數
		const NAME_MAP = {
			unscheduledNum: getLabel('h2.am.ShiftingSidePanelComps', 'numberOfUnscheduledDays'),
		};
		gridData.push(..._.map(['unscheduledNum'], key => {
			return {
				key,
				name: NAME_MAP[key],
				bef: befSummary?.[key] || 0,
				aft: aftSummary[key],
				dta: aftSummary[key] - (befSummary?.[key] || 0),
				should: '-',
				shouldDiff: '-'
			};
		}));

		return { data: gridData };
	}, [aftSummary, befSummary, calendarLeaves]);

	return gridData;
};
